export default class TherapeuticClassTranslation {
    id: number;
    name: string;
    locale: string;
    therapeutic_class_id: number;
}
